<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        Change Cell #
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Change Phone</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-form ref="form">
                <v-text-field
                  counter="13"
                  v-mask="'(###)###-####'"
                  label="Phone"
                  required
                  v-model="user.phone"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" @click="chagenPhone" text> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AgentPhoneForm",
  props: {
    user_id: Number,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    chagenPhone() {
      this.$axios
        .post("/user/update", {
          id: this.user.id,
          fields: {
            phone: this.user.phone,
          },
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
};
</script>

<style>
</style>